import {gql, useQuery} from '@apollo/client';

const IS_ADMIN_USER = gql`
    query IsAdminUser {
      isAdminUser
    }
`;

export const useIsAdminUser = () => useQuery(IS_ADMIN_USER)
